import { FilterFieldConfig } from "./types";

/** "Achata" campos compostos (`type: "period"`) nos seus `inputs`, que são os que carregam key/schema reais. */
export function getLeafFields(fields: FilterFieldConfig[]): FilterFieldConfig[] {
  return fields.flatMap((field) => (field.type === "period" && field.inputs ? field.inputs : [field]));
}

/** Um campo é considerado aplicado se sua própria key tem valor, ou (pra `"period"`) se algum dos `inputs` tem. */
export function isFieldApplied(field: FilterFieldConfig, values: Record<string, unknown>): boolean {
  if (field.type === "period" && field.inputs) {
    return field.inputs.some((input) => values[input.key] !== undefined);
  }
  return values[field.key] !== undefined;
}
